/*custom js here*/
// Check if the array exists in localStorage
let items = JSON.parse(localStorage.getItem('items')) || [];

// If 'items' doesn't exist in localStorage, initialize it as an empty array
if (!Array.isArray(items)) {
    items = [];
} else {
    let current_pass = document.getElementById("current_pass").value;
    if(items.includes(current_pass) && current_pass != "") {
        if(document.getElementById("passcode__form") != null) {
            document.getElementById("passcode__form").classList.add("hidden");
        }        
        if(document.getElementById("CollectionAjaxContent") != null) {
            document.getElementById("CollectionAjaxContent").classList.remove("hidden");
        }
        if(document.getElementById("page_content__product") != null) {
            document.getElementById("page_content__product").classList.remove("hidden");
        }        
    } 
}
// Function to add an item to the array and update localStorage
function addItemToArray(item) {
    items.push(item);
    localStorage.setItem('items', JSON.stringify(items));
}

// Example of adding items dynamically
//addItemToArray('Item 1');
//addItemToArray('Item 2');

let pass_button = document.getElementById('pass_code_confirm');

// Add a click event listener to the button
pass_button.addEventListener('click', function() {
    // Add your logic here
    let input_val = document.getElementById("pass_code").value;
    let compare_pass = document.getElementById("current_pass").value;
    console.log(input_val+"/"+compare_pass);
    if(input_val == compare_pass) {
        if(document.getElementById("passcode__form") != null) {
            document.getElementById("passcode__form").classList.add("hidden");
        }        
        if(document.getElementById("CollectionAjaxContent") != null) {
            document.getElementById("CollectionAjaxContent").classList.remove("hidden");
        }
        if(document.getElementById("page_content__product") != null) {
            document.getElementById("page_content__product").classList.remove("hidden");
        }
        addItemToArray(input_val);
    } else {
        alert("Passcode is wrong")
    }
});
